import GenericDB from './generic-db'

export default class MembershipDB extends GenericDB {
  constructor() {
    super('membership')
  }

  // Here you can extend MembershipDB with custom methods
}
